NavbarCtrl.$inject = ['$scope', '$rootScope', '$location', 'Case',
  'CurrentUser', '$uibModal', 'PaymentStatusServ', 'CreateCaseConf',
  'ReferralModalConf', '$route', '$compile', 'AnalyticsServ',
  'AccountMap', 'CurrentAccount', 'CurrentCustomer', 'AccountSetupModalConf',
  'WelcomeModalConf', 'SubscriptionStatusModalConf', '$window', 'ReloadServ',
  'Clio'
]

export default function NavbarCtrl($scope, $rootScope, $location, Case,
  CurrentUser, $uibModal, PaymentStatusServ, CreateCaseConf,
  ReferralModalConf, $route, $compile, AnalyticsServ,
  AccountMap, CurrentAccount, CurrentCustomer, AccountSetupModalConf,
  WelcomeModalConf, SubscriptionStatusModalConf, $window, ReloadServ,
  Clio) {
  $scope.user = CurrentUser.data;

  $scope.accountList = AccountMap.toArray();

  $scope.currentAccount = CurrentAccount;
  $scope.currentUser = CurrentUser;

  let unwatchAccount = $scope.$watch(() => CurrentAccount.data, (newValue,
    oldValue) => {
    if (newValue !== oldValue) {
      $scope.accountList = AccountMap.toArray();
      // unwatchAccount();
    }
  });

  CurrentCustomer.subscribe(() => {
    $scope.trialStatus = {
      daysRemaining: PaymentStatusServ.getStatus('user'),
      isTrial: PaymentStatusServ.isTrial('user')
    };
    // Analytics User Property Paid should be set when Home Page is visited.
    // Skipped for Visitors
    if (CurrentCustomer.data.id) {
      AnalyticsServ.setUser({
        id: CurrentUser.data.id,
        'Paid': PaymentStatusServ.isValid('user')
      });
    }
  })


  $scope.changeToCaseId = function (caseId) {
    // first, clear out any existing status messages - they are about
    // to become irrelevant!
    $rootScope.statusMessages = {};
    $scope.asideCasesVisible = !$scope.asideCasesVisible;
    $location.path('/home/' + caseId);
  };

  $scope.openAccountPage = function () {
    $location.path('/account')
  }

  // persisted past caseModal lifecycle
  $scope.copyCaseId = '';
  $scope.showFeedback = function () {
    if ($window.UserVoice) {
      $window.UserVoice.show();
    }
  }
  $scope.caseModal = function () {
    var m = $uibModal.open(CreateCaseConf);
    m.result.then(function (data) {
      $location.path('/home/' + data.id);
    }, function () {});
    return m;
  };
  $scope.syncClio = function () {
    Clio.sync()
  }

  $scope.accountSetupModal = function () {
    $uibModal.open(AccountSetupModalConf);
  };

  $scope.welcomeModal = function () {
    analytics.track('Welcome Modal Opened');
    let saveHidden = (guideStarted) => {
      $scope.currentUser.data.hideWelcome = true;
      $scope.currentUser.api.update();
      analytics.track('Welcome Modal Closed', {
        'Guide Opened': guideStarted
      })
    }
    if (!$rootScope.tourActive) {
      $uibModal.open(WelcomeModalConf).result.then(
        () => saveHidden(true), () => saveHidden(false)
      );
    }
  };

  if (!$scope.currentAccount.data.displayName) {
    $scope.accountSetupModal();
  }

  $scope.subscriptionModal = function (key, object) {
    // key is for the message - 'case', 'account', etc...
    // object is the object to display messaging (optional)

    // var referrer = {};

    // if ($rootScope.user.referredBy) {

    //   var referralExperiment = new OptimizelyExperiment('Referral CTA', 'Subscription Modal Clicked');

    //   referralExperiment.activate().then(function (variationId) {
    //     referrer.variation = variationId;
    //   });

    //   syncSrv.getReferrer($rootScope.user.referredBy).then(function (data) {
    //     angular.extend(referrer, data);
    //   });
    // }
    $uibModal.open(angular.extend(SubscriptionStatusModalConf, {
      resolve: {
        key: () => key,
        object: () => object
      }
    }));
  };

  $scope.referralModal = function () {
    $scope.modal = $uibModal.open(ReferralModalConf);
    analytics.track('Referral Modal Opened', {
      Origin: 'Navbar'
    });
  };
  $scope.signout = CurrentUser.api.signout;

  $scope.changeAccount = function (account) {
    CurrentUser.api.changeAccount({
      accountId: account.id
    }).then(() => {
      ReloadServ.updateTabs();
      if ($route.current.params.caseId) {
        // Reload route, clear case when set. 
        $route.updateParams({
          caseId: null
        });
      } else {
        $route.reload();
      }
    });
  };


  $scope.$on('$routeChangeSuccess', function () {
    $scope.changing = false;
  });

  if (!CurrentUser.data.hideWelcome && !$rootScope.tourActive) {
    $scope.welcomeModal();
  }

};



// WEBPACK FOOTER //
// ./project/directives/admin-nav/navbar.controller.js